<template>
    <div class="InscPayOrder">
        <div class="row">
            <div class="col-md-4">
            </div>
            <div v-if="this.viewQuery"  class="motBusUser col-md-4">
                <ValidationObserver ref="obsFields">
                    <FormUserInscription :FieldsForm="FormUserInscription" :ModelForm="this.formUserInsModel" :method="executeProcess" />
                </ValidationObserver>
                <div id="alert-danger" class="alert alert-danger noShow" role="alert" v-if="this.alertUser">
                    No se encontraron recibos de inscripción para los datos ingresados, verifique e intente nuevamente!
                </div>                 
            </div>
        </div>
        <div v-if="!this.viewQuery" class="lisTableUser motBusUser">                      
            <b-table striped hover :items="data.PayOrder" :fields="this.VendorLabel">
                <template v-slot:cell(Generar)="row">
                    <div class="text-left">
                         <img width="40" height="40" src="@/assets/images/DocNoSend.png" class="img-fluid" @click="payOrder(row.item)" alt="Generar recibo" />
                    </div>
                </template>
            </b-table>          
        </div>
    </div>
</template>

<script>
import FormUserInscription from '@/components/Forms.vue'
import FormUserFile from '@/components/Forms.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
    name: 'InscPayOrder',
    data() {
        return {
            VendorLabel: [  
                {
                    key: 'Num_Document',
                    label: 'Núm. Documento',
                    sortable: false
                },
                {
                    key: 'NamePerson',
                    label: 'Nombre',
                    sortable: false
                },
                {
                    key: 'Period',
                    label: 'Periodo',
                    sortable: false
                },             
                {
                    key: 'Num_PayOrder',
                    label: 'Orden de Pago',
                    sortable: false
                },
                {
                    key: 'CreatedDate',
                    label: 'Fecha Creación',
                    sortable: false
                },
                {
                    key: 'Generar',
                    label: 'Generar o Pagar',
                    sortable: false,
                    with: 10 
                },
            ],
            alertUser: false,
            viewQuery: true,
            data: {},
            formUserInsModel: {
                IdPeriod: '',
                IdDocument: '',
            },                                  
            FormUserInscription: [
                {            
                    id: 'NumDocument',
                    model: 'NumDocument',
                    name: 'Documento de Identidad',
                    type: 'input',  
                    placeholder: 'Documento de Identidad',
                    values: '',
                    validate: {              
                        required: true, 
                        min: 6,              
                        max: 12            
                    },
                    class: 'col-md-12'               
                },
                {            
                    id: 'IdPeriod',
                    model: 'IdPeriod',
                    name: 'Periodo',
                    type: 'Select',  
                    placeholder: "Periodo",
                    values: this.$store.state.PeriodoList,
                    validate: {              
                        required: true              
                    },
                    class: 'col-md-12',
                },
                {
                    id: 'Sch_User',
                    type: 'button',
                    placeholder: 'Consultar',
                    class: 'col-md-12',
                },                
            ],   
            FormUserFile: [],                        
        }
    },    
    components: {
        FormUserInscription,
        FormUserFile,
    },
    methods: {
        search: function() { 
            this.alertUser = false
            return new Promise((resolve, reject) => {
                this.$refs.obsFields.validate().then(results => {    
                    if (!results) {
                        IberoHelpers.scrollToTop(0,300)
                        resolve(false)
                    }else{
                        resolve(this.searchOrder())
                    }            
                })
            })
        },
        searchOrder: function() {            
            let loader = this.$loading.show();
            var NamePeriod = IberoHelpers.dataObjFind(this.$store.state.PeriodoList,this.formUserInsModel.IdPeriod);
            var totalinf = IberoHelpers.getPayOrder(this.$store.state.ApiIbero.WSUtilitary,this.formUserInsModel.NumDocument, NamePeriod)
            totalinf.then(
                Response => {      
                    if(Response.data[0] === undefined){
                        this.createOrder()
                        loader.hide()
                        return false
                    } else {
                        this.data = { PayOrder: Response.data}
                        this.viewQuery = false
                        loader.hide()
                        return true
                    }                       
                }
            )            
        },
        createOrder: function() {            
            let loader = this.$loading.show();
            var NamePeriod = IberoHelpers.dataObjFind(this.$store.state.PeriodoList,this.formUserInsModel.IdPeriod);
            var res = IberoHelpers.getRegistrationPayOrder(this.$store.state.ApiIbero.WSUtilitary,this.formUserInsModel.NumDocument, NamePeriod);
            res.then(
                Response => {
                    if(Response.data[0] === undefined){
                            this.alertUser = true
                            loader.hide()
                            return false
                    } else {
                        this.searchOrder()
                        this.viewQuery = false
                        loader.hide()
                        return true
                    }                       
                }
            )            
        },
        executeProcess: function (event) {
            switch (event.target.id) {
                case "btn_Sch_User":
                    this.search()
                break;            
                return true
            }        
        },
        payOrder: function(item){
            let loader = this.$loading.show();
            var dataLink = this.$store.state.ApiIbero.WSIceBerg;
            window.open(dataLink+"/recibo_pago.zul?numero=" + item.Num_PayOrder + "&tipo=I", "_blank");
            loader.hide();
        },     
    },   
}
</script>

<style scope>

.InscPayOrder{
    margin: 20px;
}
.totalformList{
    margin-bottom: 20px;
}
.img-fluid{
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;    
}

.txtBusUser{
    padding: 40px;
}

.lisDataUser{
    padding: 10px;
    border-radius: 10px 10px 10px 10px;
    -moz-border-radius: 10px 10px 10px 10px;
    -webkit-border-radius: 10px 10px 10px 10px;
    border: 0px solid #ffffff;
    background:  #ffffff !important;       
    margin-bottom: 5px;
}

.motBusUser{
    
    padding: 20px 5px;
    border-radius: 10px 10px 10px 10px;
    border: 2px #000 solid;
    -moz-border-radius: 10px;
    -webkit-border-radius: 10px;
    background:  #ffffff !important;       
}

header {
    background:  #ffffff !important;   
}

.table > tbody > tr > td {
    vertical-align: middle !important;
}

.active
{
    color: #222;
}

.linksActas{
    padding: 20px;
    float: right;
}

.linksReference{
    margin-top: 20px;
    padding: 20px;
    float: right;
}

.linksActas a {
  color: #222;
}
</style>